var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaikhari(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 360",
    style: {
      enableBackground: "new 0 0 1920 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000183941410664270335520000001965737183838677153_);}\r\n\t.st2{fill:url(#SVGID_00000002383725719678158470000014903185313815638675_);}\r\n\t.st3{fill:url(#SVGID_00000148647250055462200430000008339643792638490274_);}\r\n\t.st4{fill:url(#SVGID_00000047761706404351306510000008760476231999773320_);}\r\n\t.st5{fill:url(#SVGID_00000154388840118499884220000001977532117387068329_);}\r\n\t.st6{fill:#7E7E7E;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.1734,
    y1: 190.9677,
    x2: 1837.8175,
    y2: 174.4333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B08074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    style: {
      stopColor: "#97594C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#CD966D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#AE7667"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#929C79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6A549"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1323.9,20.9c-9.8,0-9.8,0-13.4,9.3c-7,17.9-13.9,35.9-21,53.8c-33.9,82.6-64.9,167.1-99.3,249.2 c-1.2-0.3-1-0.2-2.2-0.5c2.5-103.2,2.8-207.2,0.2-310.3h-64.5c0,41.3,0,82.2,0,123.4c-39.1,0-77.1,0-115.4,0 c-0.9-41,1.2-81.6-1.7-122.2c-21.5,0-42.3,0-64.7,0c0,99.4,0,198.1,0,297.4c0.8,4.9-1.3,13.8,4.6,15.7c8.8-1.4,60.4,3.8,60.4-3.3 c3-40.5,0.6-81.2,1.3-121.8c35.8-0.7,71.5,0,107.3-0.4c6.8,0,9,1.1,9,9.4c-0.1,35.8,0,71.5-0.1,107.3c0,8.9,0,9,8.8,8.9 c39.4-0.9,78.9-1.1,118.3,0c3.3,0.1,4.8-1.1,6-4.2c28.9-75.4,57.2-149.9,85.9-225.7c29.4,70.3,53.8,143.2,81.7,214.3 c5.7,15.5,5.5,15.6,21.8,15.6c17,0,33.6,0,50.9,0c-28.2-81.8-64.5-161.5-94.6-243C1364.7,6.7,1395.6,22.2,1323.9,20.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000916841041661596180000000664484571987768998_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.0983,
    y1: 183.0096,
    x2: 1837.7424,
    y2: 166.4753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B08074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    style: {
      stopColor: "#97594C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#CD966D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#AE7667"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#929C79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6A549"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000916841041661596180000000664484571987768998_)"
    },
    d: "M593.4,328.9 c-28.5-61.7-50.5-126-75.8-189.1c-15-38.6-30.2-77.1-46.1-115.4c-0.6-1.5-3-3.1-4.6-3.2C401,23.7,418,6.1,394.8,62.1 c-36.2,90-71.3,180.9-105.2,271.6c2.1,1.1,4.2,3.1,6.4,3.1c19,0.3,38,0.2,57,0.2c29-77,57.8-153.2,86.8-230.3 c29.8,74.8,56.6,150.7,85.4,225.8c1.4,3.9,3.6,4.7,7.5,4.7c41.6-0.4,83.2,0.5,124.7-0.4c0-104.7,0-208.9,0-313.2 c-21.4,0-42.2,0-64.1,0C593.4,125.6,593.4,227.2,593.4,328.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013180508555072613640000000650023439465209776_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.2064,
    y1: 194.4743,
    x2: 1837.8506,
    y2: 177.9399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B08074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    style: {
      stopColor: "#97594C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#CD966D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#AE7667"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#929C79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6A549"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013180508555072613640000000650023439465209776_)"
    },
    d: "M1741.1,162.9 c13.5-50.3-1.8-110.9-54-131.1c-16.7-7.3-34.8-8.9-52.8-9.2c-41.1-0.4-82.4,1.9-123.5,0.5c-7.6-1.4-8.5-0.6-8.5,7 c0,102.3,0,204.5,0,306.8c22,0,43.2,0,65.2,0c0-33.1,0-65.9,0-99.2c16.1,0,31.5,0,46.9,0.1c1.2,0,2.7,1.2,3.4,2.2 c18.6,29.4,36.6,59.2,55,88.8c3.6,5.7,7.9,9.2,15.8,8.7c22.8-1.1,42.3,0.1,66-0.3c-24.1-37.8-47.2-74.2-70.6-111 C1710.7,211.4,1733.1,193.9,1741.1,162.9z M1567.5,175.6c0-30.5,0-59.6,0-89.1c36.5,2.3,104-15.1,111.1,36.3 C1685.5,192.9,1612.9,170.8,1567.5,175.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054238632249672289690000001013693888378946700_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.1386,
    y1: 187.2851,
    x2: 1837.7827,
    y2: 170.7508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B08074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    style: {
      stopColor: "#97594C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#CD966D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#AE7667"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#929C79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6A549"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054238632249672289690000001013693888378946700_)"
    },
    d: "M931.1,23.7c-23.8-0.9-46.7,0.1-70.4-0.5 c-5-0.1-8.2,1.5-11.5,5.3c-38,43.4-73.6,86.8-112.3,129.7V23.6h-64.1v313.2h64.3c0-29.7,0.1-59.1-0.1-88.7c0-3.9,0.5-7,3.6-9.9 c9.7-11.4,18.8-22,29.5-33.2c28.2,43.6,57.8,84.8,86.2,128c2.1,3.1,4.6,4.6,8.7,4.5c23.4-0.4,46.9-0.1,70.3-0.2 c0.3-0.6,0.4-0.8,0.8-1.4c-40-60.2-81.6-119.3-121.8-179.3C853.3,112.3,891.8,68.5,931.1,23.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141423946552321194260000005003891982819870640_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.0884,
    y1: 181.9571,
    x2: 1837.7324,
    y2: 165.4227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B08074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    style: {
      stopColor: "#97594C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#CD966D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#AE7667"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#929C79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6A549"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141423946552321194260000005003891982819870640_)"
    },
    d: "M317.6,23.6c-1.2,0-2.9,1.6-3.4,2.9 c-26,70.7-49.5,142.3-74.1,213.5c-0.5,0-1,0-1.6,0c-23.2-71.2-49-141.5-72.9-212.5c-1.3-3.7-2.9-5.6-7.4-5.4 c-21.9-0.2-43.1,0.9-65.1,1.3c36.2,104.4,77.3,207.6,115.4,311.5c1.2,3.2,2.7,4.6,6.3,4.6c15.8-0.2,31.6-0.1,47.4,0 c3.3,0,4.9-0.9,6.1-4c4-10.4,8.5-20.7,12.4-31.2c33.6-93.5,69.7-186.1,103-279.7C362.4,22.3,339.5,24.3,317.6,23.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039833877764967493090000003844694661468746425_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.2259,
    y1: 196.5355,
    x2: 1837.87,
    y2: 180.0011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B08074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2095,
    style: {
      stopColor: "#97594C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385,
    style: {
      stopColor: "#CD966D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#AE7667"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#929C79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6A549"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039833877764967493090000003844694661468746425_)"
    },
    d: "M1826.8,30c0-6-2-6.9-7-6.8 c-16.6,0.2-33.2,0.2-49.8,0.3c-8,0-8.3,0.3-8.3,8.5c0.7,101.8-1.3,203.4,0.8,305.2c19.6,0,38.7-0.2,57.8,0.1 c5.2,0.1,6.5-2.2,6.5-6.7C1826.9,230.4,1826.5,130.2,1826.8,30z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M438.6,276.6c-7.3,19.9-14.6,39.9-22.1,60.3h47.2c-7.7-20.6-15.1-40.5-22.5-60.3 C439.9,276.6,439.9,276.6,438.6,276.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1343.6,276.3c-7.2,20-14.5,40.1-21.9,60.6h46.2c-7.5-20.5-14.8-40.6-22.1-60.6 C1344.6,276.3,1344.6,276.3,1343.6,276.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaikhari);
export default __webpack_public_path__ + "static/media/vaikhari.6a4cc019bea6f4f5642753361afee76b.svg";
export { ForwardRef as ReactComponent };